import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Tooltip } from 'antd';
import { BranchesOutlined } from '@ant-design/icons';
import { txt } from 'libs/i18n';
import IconButton from 'components/IconButton';
import { useSwitch } from 'hooks/useSwitch';
import { useMemo } from 'react';
import MergeModal from './MergeModal';
import styles from './style.module.less';
const MIN_SPEAKERS_FOR_MERGE = 2;
const MAX_SPEAKERS_FOR_MERGE = 10;
const MergeButton = ({ selectedSpeakerRows, onSuccess, }) => {
    const [openDialog, onOpenDialog, onCloseDialog] = useSwitch();
    const countSelected = selectedSpeakerRows.length;
    const isDisabled = useMemo(() => countSelected === 0
        || countSelected < MIN_SPEAKERS_FOR_MERGE
        || countSelected > MAX_SPEAKERS_FOR_MERGE, [countSelected]);
    return (_jsxs("div", { children: [_jsx(Tooltip, { title: txt('merge'), children: _jsx("span", { children: _jsx(IconButton, { disabled: isDisabled, onClick: onOpenDialog, className: styles.toolbarButton, children: _jsx(BranchesOutlined, { className: styles.toolbarButton }) }) }) }), openDialog && (_jsx(MergeModal, { open: openDialog, onClose: onCloseDialog, selectedSpeakerRows: selectedSpeakerRows, onSuccess: onSuccess }))] }));
};
export default MergeButton;
